import AppButton from '@nxsys/components/AppButton';
import AppInput from '@nxsys/components/AppInputSearch';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';

type ActionsHeaderProps = {
  onApply: () => void;
  onCancel: () => void;
  searchValue: string;
  onSearchChange: (value: string) => void;
  isShowActions: boolean;
  onSync: () => void;
};

export const ActionsHeader = ({
  onApply,
  onCancel,
  searchValue,
  onSearchChange,
  isShowActions,
  onSync,
}: ActionsHeaderProps) => {
  const { messages } = useTypedIntl();

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onSearchChange(event.target.value);
  };

  return (
    <div className="flex items-center gap-2 justify-between w-full">
      <AppInput value={searchValue} onChange={handleSearchChange} />

      {isShowActions && (
        <div className="flex items-center gap-2">
          <AppButton
            type="primary"
            name={messages['common.hmrcSync']}
            onClick={onSync}
          />
          <AppButton
            type="primary"
            name={messages['common.apply']}
            onClick={onApply}
          />
          <AppButton
            type="primary"
            name={messages['common.cancel']}
            onClick={onCancel}
          />
        </div>
      )}
    </div>
  );
};
